import { Button } from '@/components/ui/button';
import { useWebsiteT } from '../hooks/use-website-t';

export interface LegacyConversionNoticeProps {
  readonly onViewReport: () => void;
}

/** A converted store: some parts of its original design are locked. */
export function LegacyConversionNotice({
  onViewReport,
}: LegacyConversionNoticeProps): React.JSX.Element {
  const { t } = useWebsiteT();
  return (
    <div
      role="status"
      data-testid="legacy-conversion-notice"
      className="border-border bg-admin-surface-muted flex flex-wrap items-center justify-between gap-2 border-b px-4 py-2 text-sm"
    >
      <span>{t('admin.websiteTemplates.editor.legacyNotice')}</span>
      <Button type="button" variant="link" size="sm" className="h-auto p-0" onClick={onViewReport}>
        {t('admin.websiteTemplates.editor.legacyReport')}
      </Button>
    </div>
  );
}
